{
  "clear": "Изчисти",
  "invalid": "(невалиден)",
  "loading": "Зареждане...",
  "noResults": "Няма резултати",
  "valid": "(валидно)"
}
